import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@cb/solaris-react/Components/Content/Icon';
import { Size } from '@cb/solaris-react/Constants/System';
import { useState } from 'react';
import styled from 'styled-components';
const defaultProps = {
    size: Size.medium,
};
export default function HeaderSearchBar(props) {
    const { onSearchChange, onSearchCleared, placeholder, className, size } = { ...defaultProps, ...props };
    const [query, setQuery] = useState('');
    const handleSearchQueryChanged = (e) => {
        const value = e.target.value;
        setQuery(value);
        onSearchChange?.(value);
    };
    const handleClearClicked = () => {
        if (query.trim().length > 0) {
            setQuery('');
            onSearchCleared?.();
        }
    };
    return (_jsxs(SearchBarContainer, { className: className, size: size, children: [_jsx(StyledSearchBar, { onChange: handleSearchQueryChanged, value: query, placeholder: placeholder }), _jsx(StyledIcon, { name: query.trim().length > 0 ? 'x' : 'search', onClick: handleClearClicked })] }));
}
const StyledIcon = styled(Icon) ``;
const StyledSearchBar = styled.input ``;
const SearchBarContainer = styled.div `
	color: ${(props) => props.theme.schemes.primary.text};
	position: relative;
	width: 100%;
	display: flex;
	align-items: center;

	${StyledSearchBar} {
		color: ${(props) => props.theme.schemes.primary.text};
		height: ${({ theme, size }) => {
    switch (size) {
        case Size.large:
            return theme.sizing.lg;
        case Size.medium:
            return theme.sizing.md;
        case Size.small:
            return theme.sizing.sm;
    }
}};
		background-color: ${(props) => props.theme.palette.shade6};
		padding-inline: 13px
			calc(
				${({ theme }) => theme.typography.md} +
					${({ theme, size }) => {
    switch (size) {
        case Size.large:
            return theme.spacing.xl;
        case Size.medium:
            return theme.spacing.lg;
        case Size.small:
            return theme.spacing.md;
    }
}}
			);
		flex-grow: 1;
		border: none;
		width: 100%;
		border: 1px solid transparent;

		&:focus {
			border: 1px solid ${(props) => props.theme.palette.success};
			outline: 0;
		}
	}

	${StyledIcon} {
		cursor: pointer;
		position: absolute;
		right: ${({ theme, size }) => {
    switch (size) {
        case Size.large:
            return theme.spacing.lg;
        case Size.medium:
            return theme.spacing.md;
        case Size.small:
            return theme.spacing.sm;
    }
}};
	}
`;
//# sourceMappingURL=HeaderSearchBar.js.map